// Mock data for Healthsqur clone (frontend-only)

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#why" },
  { label: "Contact", href: "#book" },
];

export const HERO = {
  badge: "100% Verified & Trained Caregivers",
  titleTop: "Expert medical",
  titleMid: "care,",
  titleHighlight: "delivered at home",
  subtitle:
    "From nursing and elder care to post-operative recovery — Healthsqur brings trusted, trained professionals to your doorstep. Care that feels like family, backed by clinical rigour.",
  images: {
    elder: "/generated/hero_elder.png",
    nurse: "/generated/hero_care.png",
    home: "/generated/hero_family.png",
  },
  stats: [
    { value: "500+", label: "Verified Caregivers" },
    { value: "600+", label: "Happy Families" },
    { value: "4.8\u2605", label: "Google Rating" },
  ],
};

// Rotating hero storytelling slides (one visible at a time)
export const HERO_SERVICES = [
  {
    key: "nursing",
    icon: "Stethoscope",
    title: "Nursing Care",
    desc: "Professional nursing care at home by trained and experienced nurses.",
    img: "/generated/hero_nursing.png",
  },
  {
    key: "elder",
    icon: "HeartHandshake",
    title: "Elder Care",
    desc: "Compassionate assistance and daily support for senior citizens at home.",
    img: "/generated/hero_elder.png",
  },
  {
    key: "postop",
    icon: "Activity",
    title: "Post-Operative Care",
    desc: "Expert recovery care after surgery in the comfort of your home.",
    img: "/generated/hero_postop.png",
  },
  {
    key: "mother",
    icon: "Baby",
    title: "Mother & Baby Care",
    desc: "Specialised care for mothers and newborns during recovery and early care.",
    img: "/generated/hero_mother_baby.png",
  },
  {
    key: "physio",
    icon: "Dumbbell",
    title: "Physiotherapy",
    desc: "Personalised physiotherapy sessions to improve mobility and recovery.",
    img: "/generated/hero_physio.png",
  },
  {
    key: "icu",
    icon: "HeartPulse",
    title: "ICU at Home",
    desc: "Advanced critical care services with hospital-grade equipment at home.",
    img: "/generated/hero_icu.png",
  },
  {
    key: "doctor",
    icon: "BriefcaseMedical",
    title: "Doctor Visit at Home",
    desc: "Qualified doctors providing consultations and treatment at your doorstep.",
    img: "/generated/hero_doctor.png",
  },
  {
    key: "lab",
    icon: "TestTubes",
    title: "Lab Tests at Home",
    desc: "Convenient home sample collection with accurate diagnostic testing.",
    img: "/generated/hero_lab.png",
  },
];


export const TRUST_STATS = [
  { value: "600+", label: "Families Served", icon: "Users" },
  { value: "8,000+", label: "Home Visits Delivered", icon: "Home" },
  { value: "4.8\u2605", label: "Avg. Google Rating", icon: "Star" },
  { value: "100%", label: "Verified Caregivers", icon: "ShieldCheck" },
];

export const SERVICES = [
  {
    slug: "nursing-care",
    icon: "Stethoscope",
    title: "Nursing Care",
    desc: "Clinical nursing at home by qualified nurses — IV therapy, injections, catheter care, wound dressing and vitals monitoring.",
    points: ["IV & injection administration", "Wound dressing & catheter care", "Vital-sign monitoring"],
    about:
      "Our home nursing service brings hospital-grade clinical care to your doorstep, delivered by qualified and experienced nurses. Whether it is short-term recovery support or long-term critical care, every nurse is trained, verified and supervised by a dedicated care manager — so your family receives safe, dignified medical attention without repeated hospital visits.",
    includes: [
      "IV therapy and injection administration",
      "Wound dressing and post-surgical care",
      "Catheter insertion, care and replacement",
      "Vital-sign and medication monitoring",
      "Ryles tube and tracheostomy care",
      "12-hour and 24-hour live-in options",
    ],
    img: "/generated/svc_nursing.png",
    detailImg: "/generated/svc_detail_nursing.png",
  },
  {
    slug: "elder-care",
    icon: "HeartHandshake",
    title: "Elder Care",
    desc: "Compassionate day-to-day support for ageing parents — hygiene, safe mobility and warm companionship at home.",
    points: ["Bathing, grooming & feeding", "Fall prevention & mobility support", "Medication reminders & companionship"],
    about:
      "Ageing should be comfortable and dignified. Our trained caregivers help senior citizens with everyday activities while preserving their independence — offering steady physical assistance, fall prevention and genuine companionship. For families balancing work and care, a Healthsqur caregiver brings reassurance and routine stability at home.",
    includes: [
      "Assistance with bathing and grooming",
      "Supervised, safe mobility and fall prevention",
      "Medication reminders and routine management",
      "Companionship and emotional support",
      "Day-shift, night-shift and live-in options",
    ],
    img: "/generated/svc_elder.png",
    detailImg: "/generated/svc_detail_elder.png",
  },
  {
    slug: "post-operative-care",
    icon: "Activity",
    title: "Post-Operative Care",
    desc: "A safe hospital-to-home transition after surgery — mobility help, wound hygiene and gradual strengthening.",
    points: ["Mobility & toileting assistance", "Dressing & hygiene support", "Guided recovery routines"],
    about:
      "The days after surgery are critical to a full recovery. Our post-operative care ensures a smooth, safe transition from hospital to home — with attentive nurses and caregivers who manage wounds, mobility and daily routines, reducing the risk of complications and readmission while you heal comfortably at home.",
    includes: [
      "Post-surgical wound care and dressing",
      "Mobility, transfer and toileting assistance",
      "Bathing, dressing and hygiene support",
      "Medication and pain-management support",
      "Guided strengthening and recovery routines",
      "Coordination with your treating doctor",
    ],
    img: "/generated/svc_postop.png",
    detailImg: "/generated/svc_detail_postop.png",
  },
  {
    slug: "mother-baby-care",
    icon: "Baby",
    title: "Mother & Baby Care",
    desc: "Trained attendants for new mothers and newborns during those first delicate weeks of recovery and care.",
    points: ["Newborn & postnatal support", "Feeding & hygiene assistance", "Restful night-care support"],
    about:
      "The first weeks with a newborn are precious and demanding. Our trained maternity attendants support new mothers through postnatal recovery and help care for the baby — from feeding and hygiene to soothing night routines — so mothers can rest, heal and bond with confidence.",
    includes: [
      "Newborn care, bathing and hygiene",
      "Breastfeeding and feeding assistance",
      "Postnatal recovery support for the mother",
      "Baby sleep and soothing routines",
      "Restful night-care support",
      "Guidance for first-time parents",
    ],
    img: "/generated/svc_mother_baby.png",
    detailImg: "/generated/svc_detail_mother_baby.png",
  },
  {
    slug: "physiotherapy",
    icon: "Dumbbell",
    title: "Physiotherapy",
    desc: "Personalised physiotherapy at home for stroke, fracture, knee-replacement and mobility recovery.",
    points: ["Post-stroke & fracture rehab", "Pain relief & mobility work", "Guided daily exercises"],
    about:
      "Recovery is faster and more comfortable at home. Our physiotherapists design personalised sessions for post-stroke, fracture, joint-replacement and mobility conditions — combining hands-on therapy with guided exercises to restore strength, movement and confidence, one session at a time.",
    includes: [
      "Post-stroke and neuro rehabilitation",
      "Fracture and joint-replacement recovery",
      "Pain relief and mobility improvement",
      "Personalised exercise programmes",
      "Posture and gait correction",
      "Progress tracking with your care manager",
    ],
    img: "/generated/svc_physio.png",
    detailImg: "/generated/svc_detail_physio.png",
  },
  {
    slug: "icu-at-home",
    icon: "HeartPulse",
    title: "ICU at Home",
    desc: "Hospital-grade critical care set up inside your home with trained staff and continuous monitoring.",
    points: ["Ventilator & monitoring setup", "Trained critical-care nurses", "24/7 supervision"],
    about:
      "For patients who need intensive care but prefer the comfort of home, we recreate a hospital-grade ICU setup at your residence — complete with monitoring equipment, trained critical-care nurses and round-the-clock supervision, coordinated closely with your doctors for continuous, safe care.",
    includes: [
      "Hospital-grade monitoring equipment",
      "Ventilator and oxygen support",
      "Trained critical-care nurses",
      "24/7 monitoring and supervision",
      "Emergency response coordination",
      "Doctor and equipment coordination",
    ],
    img: "/generated/svc_icu.png",
    detailImg: "/generated/svc_detail_icu.png",
    keyComponentsIntro:
      "ICU at Home provides high-dependency care services to patients who are no longer in the acute phase of their illness but are not yet fully ready for an ICU discharge.",
    keyComponents: [
      { icon: "Stethoscope", label: "Skilled Nursing Care" },
      { icon: "Activity", label: "24x7 Vital Monitoring" },
      { icon: "Syringe", label: "IV Administration" },
      { icon: "Cog", label: "Equipment Handling" },
      { icon: "BedDouble", label: "Pressure Ulcer Prevention" },
      { icon: "Cable", label: "Care of Tubes & Catheters" },
      { icon: "ShieldCheck", label: "Infection Control" },
      { icon: "Bandage", label: "Wound Dressing" },
      { icon: "Footprints", label: "DVT Prevention" },
      { icon: "Dumbbell", label: "Physiotherapy" },
      { icon: "PersonStanding", label: "Activities of Daily Living" },
      { icon: "Brain", label: "Psychological Counselling" },
    ],
  },
  {
    slug: "doctor-visit-at-home",
    icon: "BriefcaseMedical",
    title: "Doctor Visit at Home",
    desc: "Qualified doctors visit you at home for consultations, evaluations and follow-up prescriptions.",
    points: ["Fever, BP & weakness reviews", "Clinical evaluation at home", "Prescriptions & follow-ups"],
    about:
      "Skip the waiting room. Our qualified doctors visit you at home for consultations, evaluations and follow-ups — ideal for elderly patients, fever, blood-pressure fluctuations or recovery reviews. You get unhurried, personal attention and a clear care plan, all within the comfort of home.",
    includes: [
      "General physician consultations at home",
      "Evaluation of fever, weakness and BP",
      "Prescriptions and treatment plans",
      "Follow-up and review visits",
      "Referral coordination when needed",
      "Same-day availability in most areas",
    ],
    img: "/generated/svc_doctor.png",
    detailImg: "/generated/svc_detail_doctor.png",
  },
  {
    slug: "lab-tests-at-home",
    icon: "TestTubes",
    title: "Lab Tests at Home",
    desc: "Doorstep sample collection with fast, accurate diagnostic reports — no travel, no waiting.",
    points: ["At-home sample collection", "Diabetes, kidney & infection panels", "Fast, accurate reports"],
    about:
      "Diagnostics made effortless. A trained phlebotomist collects samples at your doorstep and reports are delivered digitally — accurate, timely and hassle-free. From routine health checks to condition-specific panels, testing fits neatly into your day with no travel and no waiting.",
    includes: [
      "At-home blood sample collection",
      "Diabetes, kidney and liver panels",
      "Infection and inflammation markers",
      "Routine full-body health checks",
      "Fast, accurate digital reports",
      "Reports that guide doctor consultations",
    ],
    img: "/generated/svc_lab.png",
    detailImg: "/generated/svc_detail_lab.png",
  },
  {
    slug: "trained-attendants",
    icon: "Users",
    title: "Trained Attendants",
    desc: "Compassionate, background-verified attendants for round-the-clock personal care, mobility support and companionship at home.",
    points: ["Personal hygiene & mobility help", "Meal, medication & routine support", "Warm, dependable companionship"],
    about:
      "Our trained attendants are the dependable hands and steady presence a family needs at home. Carefully selected, background-verified and trained in patient handling, hygiene and safety, they support bedridden, elderly and recovering patients with daily activities — while offering the warmth and companionship that makes care feel personal. Every attendant is supervised by a dedicated care manager, so your loved one is never alone and always in safe hands.",
    includes: [
      "Assistance with bathing, grooming and hygiene",
      "Safe mobility, transfers and fall prevention",
      "Feeding and meal-time assistance",
      "Medication reminders and routine management",
      "Companionship and emotional support",
      "12-hour, night-shift and 24-hour live-in options",
    ],
    img: "/generated/svc_attendee.png",
    detailImg: "/generated/svc_detail_attendee.png",
  },
];

export const WHY = {
  image: "/generated/why_care.png",
  statValue: "94%",
  statLabel: "Family satisfaction rate across 500+ homes",
  features: [
    {
      icon: "BadgeCheck",
      title: "Verified & Background Checked",
      desc: "Every caregiver is police-verified and reference-checked before onboarding.",
    },
    {
      icon: "GraduationCap",
      title: "Trained & Skilled Caregivers",
      desc: "Regular training modules for quality, safety, empathy and clinical skills.",
    },
    {
      icon: "Clock",
      title: "24/7 On Standby",
      desc: "Round-the-clock support and rapid response for critical care needs.",
    },
    {
      icon: "RefreshCw",
      title: "Hassle-Free Replacements",
      desc: "Not happy with your caregiver? We arrange a quick, no-fuss replacement.",
    },
  ],
};

export const STEPS = [
  {
    num: "01",
    title: "Share Your Requirement",
    desc: "Tell us about your loved one — their condition, routine and care needs.",
  },
  {
    num: "02",
    title: "Get Matched With The Right Caregiver",
    desc: "Our care manager matches you with a trained caregiver from our verified network.",
  },
  {
    num: "03",
    title: "Care Begins, We Stay Involved",
    desc: "Daily monitoring, records and a dedicated care manager for ongoing support.",
  },
];

export const DIRECTORY = {
  Care: [
    "Post Operative Care",
    "Elderly Care",
    "Bedridden Patient Care",
    "Diabetic Care",
    "Intensive Care",
    "Dementia Care",
    "Mother & Baby Care",
    "Urinary Catheterisation Care",
    "Neurological Care",
    "Alzheimer's Care",
    "Orthopedic Care",
    "Post Hip Surgery Care",
    "Post Knee Replacement Care",
  ],
  Support: [
    "Travel Assistant",
    "Bathing & Personal Hygiene",
    "Oral Medication Administration",
    "Walking & Bedside Exercises",
    "Colostomy Bag Changing Assistance",
    "Recovery Support",
    "Hospital Attendant Services",
    "Nebulisation",
  ],
  Procedures: [
    "Wound Dressing at Home",
    "Injections Administration & IV Infusion",
    "Bed Sore Treatment",
    "Occupational Therapy",
    "Vaccination",
    "Oxygen Administration",
    "Urine Bag Emptying & Diaper Changing Assistance",
    "BiPAP / CPAP",
    "Ryles Tube Insertion",
  ],
  "Special Observation": [
    "Tracheostomy Care",
    "Craniotomy Care",
    "Feeding Tube Care",
    "Oncology Care",
    "Parkinson's Care",
    "Trauma Care",
    "Spine Care",
    "ICU at Home",
    "Cardiac Care",
    "COMA Patients Care",
    "Stroke Care",
    "Paralysis Care",
  ],
  "Other Offerings": [
    "Medical Equipment",
    "Counselling",
    "Corporate Health",
    "Nutrition & Diet Consultation",
    "Physiotherapy at Home",
    "Lab Tests at Home",
    "Doctor Visit at Home",
  ],
};

export const PLANS = [
  {
    tag: "2 – 4 hrs",
    title: "Short Visits",
    desc: "For special handlings, dressings, injections or quick check-ins.",
    price: "800",
    unit: "per visit",
    popular: false,
  },
  {
    tag: "8 – 10 hrs",
    title: "Day Shift Care",
    desc: "A caregiver by their side through the day for daily living & routine care.",
    price: "1,250",
    unit: "per shift",
    popular: true,
  },
  {
    tag: "24 hrs",
    title: "Live-In Care",
    desc: "A dedicated live-in caregiver for round-the-clock support at home.",
    price: "1,500",
    unit: "per shift",
    popular: false,
  },
  {
    tag: "Daily",
    title: "Daily Care Package",
    desc: "Long-term monthly care packages with a dedicated care manager.",
    price: "Custom",
    unit: "tailored plan",
    popular: false,
  },
];

export const PLAN_FEATURES = [
  "Dedicated care manager",
  "Verified & trained caregivers",
  "Daily record monitoring",
];

export const CITIES = [
  "Bengaluru",
  "Hyderabad",
  "Chennai",
  "Kolkata",
  "Kochi",
  "Coimbatore",
];

export const TESTIMONIALS = [
  {
    text: "Healthsqur felt like a mother to a newborn — that gentle, watchful, always-there kind of care. Their nurse handled my father's post-op recovery beautifully.",
    name: "Ananya Sharma",
    city: "Bengaluru",
    initial: "A",
  },
  {
    text: "After my mother's stroke, we were lost. Their care manager guided us step by step. The caregiver knew exactly what to do and treated her with real dignity.",
    name: "Rakesh Menon",
    city: "Chennai",
    initial: "R",
  },
  {
    text: "Booked a night nurse for my newborn. Trained, calm and so patient with a first-time mom like me. Genuinely changed how I slept in those early weeks.",
    name: "Priya Iyer",
    city: "Hyderabad",
    initial: "P",
  },
  {
    text: "Their ICU-at-home setup for my grandfather saved us so many hospital days. Equipment, nurse, doctor visits — all coordinated without us lifting a finger.",
    name: "Sanjay Verma",
    city: "Coimbatore",
    initial: "S",
  },
];

export const FAQS = [
  {
    q: "What services does Healthsqur offer at home?",
    a: "We offer nursing care, elder care, post-operative care, mother & baby care, physiotherapy, ICU at home, doctor visits and lab tests — all delivered at your doorstep by verified professionals.",
  },
  {
    q: "How are your caregivers verified?",
    a: "Every caregiver goes through police verification, reference checks and skill assessments before onboarding, followed by regular training modules.",
  },
  {
    q: "Can I get a replacement if I'm not satisfied?",
    a: "Absolutely. If you're not happy with your caregiver, our care manager arranges a quick, hassle-free replacement at no extra cost.",
  },
  {
    q: "Do you provide services in my city?",
    a: "We currently serve 6 cities across India — Bengaluru, Hyderabad, Chennai, Kolkata, Kochi and Coimbatore, with more coming soon.",
  },
  {
    q: "Is there a registration or onboarding fee?",
    a: "No. Consultation with a care manager is completely free, and there are no hidden registration or onboarding charges.",
  },
];

export const CITIES_SELECT = CITIES;
export const SERVICES_SELECT = [
  "Nursing Care",
  "Elder Care",
  "Post-Operative Care",
  "Mother & Baby Care",
  "Physiotherapy",
  "ICU at Home",
  "Doctor Visit at Home",
  "Lab Tests at Home",
  "Trained Attendants",
];
